import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

const BASE = (import.meta.env.VITE_API_URL as string | undefined) ?? 'http://127.0.0.1:8787';

export interface ActivityLogUser {
  id: string;
  name: string;
  email: string;
  role: string;
}

export interface ActivityLog {
  id: string;
  userId: string | null;
  action: 'create' | 'update' | 'delete' | 'login' | 'logout';
  entity: 'product' | 'category' | 'product_image' | 'product_sizes' | 'session';
  entityId: string | null;
  entityName: string | null;
  description: string | null;
  level: 'info' | 'warning' | 'error';
  metadata: string | null;
  createdAt: number;
  user: ActivityLogUser | null;
}

export interface LogsPage {
  items: ActivityLog[];
  page: number;
  limit: number;
  total: number;
}

export interface GetLogsParams {
  page?: number;
  limit?: number;
  entity?: string;
  action?: string;
  level?: string;
}

export const logsApi = createApi({
  reducerPath: 'logsApi',
  baseQuery: fetchBaseQuery({
    baseUrl: BASE,
    prepareHeaders: (headers) => {
      const token = localStorage.getItem('auth_token');
      if (token) headers.set('Authorization', `Bearer ${token}`);
      return headers;
    },
  }),
  endpoints: (builder) => ({
    getLogs: builder.query<LogsPage, GetLogsParams>({
      query: (params) => {
        const qs = new URLSearchParams();
        if (params.page)   qs.set('page',   String(params.page));
        if (params.limit)  qs.set('limit',  String(params.limit));
        if (params.entity) qs.set('entity', params.entity);
        if (params.action) qs.set('action', params.action);
        if (params.level)  qs.set('level',  params.level);
        return `/api/v1/logs?${qs}`;
      },
      transformResponse: (res: { status: string; data: LogsPage }) => res.data,
    }),
  }),
});

export const { useGetLogsQuery } = logsApi;
